import React from 'react'
import './ProductAccessories.css'

const ProductAccessories = () => {
  return (
    <div className='product_container'>
      <div className='block'>
        <div className='droebit'>
          <h1>პროდუქტი მალე დაემატება...</h1>
        </div>
        {/* <div className='first'>
          <img src="/images/speakers/1.jpg" alt="First" />
          <h1>WILLEN</h1>
        </div>
        <div className='second'>
          <img src="/images/speakers/2.jpg" alt="Second" />
          <h1>EMBERTON II</h1>
        </div> */}
      </div>
    </div>
  )
}

export default ProductAccessories